import * as yup from "yup";

const schema = yup.object().shape({
  tab: yup.object().shape({
    name: yup
      .string()
      .min(3, "Minimum 3 characters")
      .required("Name is required"),
    children: yup
      .array()
      .nullable()
      .of(
        yup.object().shape({
          name: yup
            .string()
            .min(3, "Minimum 3 characters")
            .required("Name is required"),
          children: yup
            .array()
            .nullable()
            .of(
              yup.object().shape({
                name: yup
                  .string()
                  .min(3, "Minimum 3 characters")
                  .required("Name is required"),
              })
            ),
        })
      ),
    skill_id: yup
      .array()
      .of(yup.string())
      .nullable(true)
      .when("global", {
        is: false,
        then: yup
          .array()
          .of(yup.string())
          .nullable(true)
          .required("Select skill or enable global mode"),
        otherwise: yup.array().of(yup.string()).nullable(true),
      }),
    global: yup.boolean().required("Global is required"),
  }),
});

export default schema;
